import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NoContentRoutingModule } from './no-content.routing';
import { NoContentComponent }   from './no-content.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    NoContentRoutingModule,
    MatIconModule
  ],
  exports: [],
  declarations: [ NoContentComponent ],
  providers: [],
})
export class NoContentModule {
}
